import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  StyledListGroupFontItem,
  StyledListGroupMyFont,
  StyledMyFontTitle,
  StyledMyFontListWrapper,
} from "../../../../styled/styleFontBrowser";
import { connect } from "react-redux";
import {
  deleteFont,
  fetchFonts,
} from "../../../../../_actions/appActions";
import { Spinner } from "@chakra-ui/react";
import { FaTimes } from "react-icons/fa";
import { withTranslation } from "react-i18next";
import TLDRInfiniteScroll from "apps/simplified-web/src/_components/common/TLDRInfiniteScroll";
import { isEmpty } from "lodash";
import axios from "axios";
import Preloader from '../../../../social/Preloader/Preloader'
class MyFontList extends Component {
  signal = axios.CancelToken.source();
  constructor(props) {
    super(props);
    this.state = {
      deletingFont: [],
      loading: false,
    };
    this.listRef = React.createRef();
    this.loadMoreFonts = this.loadMoreFonts.bind(this);
  }

  componentDidMount() {
    if (isEmpty(this.props.fonts)) {
      this.fetchMyFontList(1);
    }
  }

  fetchMyFontList(page) {
    this.setState({ ...this.state, loading: true });
    this.props
      .fetchMyFontList(this.props, this.signal, page)
      .then(() => this.setState({ ...this.state, loading: false }))
      .catch((err) => this.setState({ ...this.state, loading: false }));
  }

  loadMoreFonts() {
    this.fetchMyFontList(this.props.page);
  }

  render() {
    let { fonts } = this.props;
    const { t, hasMore } = this.props;
    const { loading } = this.state;
    fonts = fonts.filter((font, index) => !(font.organization === null));
    const fontItems = fonts.map((font, index) => {
      return (
        <StyledListGroupFontItem family={font.family} key={index} p={3}>
          <div>{font.family}</div>

          {this.state.deletingFont.indexOf(font.id) > -1 ? (
            <Spinner size="sm" colorScheme="primary" />
          ) : (
            <FaTimes onClick={(event) => this.deleteFont(font)} />
          )}
        </StyledListGroupFontItem>
      );
    });

    return (
      <StyledMyFontListWrapper>
        <StyledMyFontTitle>{t("my_fonts")}</StyledMyFontTitle>
        <StyledListGroupMyFont id="tldr-my-fonts-list">
          <TLDRInfiniteScroll
            className="view-all-templates-infinite-scroll"
            childrens={fontItems}
            hasMore={hasMore}
            loadMoreData={this.loadMoreFonts}
            scrollableTarget="tldr-my-fonts-list"
            loaded={loading}
            showLoading
          />

          {fonts.length === 0 && !loading && (
            <StyledListGroupFontItem>
              <div>{t("add_fonts")}</div>
            </StyledListGroupFontItem>
          )}
          {loading && (
            <Preloader size="md" mb="4" />
          )}
        </StyledListGroupMyFont>
      </StyledMyFontListWrapper>
    );
  }

  deleteFont = (font) => {
    this.setState(
      {
        ...this.state,
        deletingFont: this.state.deletingFont.concat([font.id]),
      },
      () => {
        this.props.deleteFont(font.id, this.props);
        this.setState({
          ...this.state,
          deletingFont: this.state.deletingFont.filter(
            (id, index) => id !== font.id
          ),
        });
      }
    );
  };
}

MyFontList.propTypes = {
  fonts: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  fonts: state.app.myFontList,
  hasMore: state.app.loadMoreFonts,
  page: state.app.pageFonts,
});

const mapDispatchToProps = (dispatch) => ({
  deleteFont: (id, props) => dispatch(deleteFont(id, props)),
  fetchMyFontList: (props, signal, page) =>
    dispatch(fetchFonts(props, signal, page)),
});

export default withTranslation(["fontlist"])(
  connect(mapStateToProps, mapDispatchToProps)(MyFontList)
);
